import { render, staticRenderFns } from "./EditTranscriptPrompt.vue?vue&type=template&id=d62d66fe&scoped=true&"
import script from "./EditTranscriptPrompt.vue?vue&type=script&lang=js&"
export * from "./EditTranscriptPrompt.vue?vue&type=script&lang=js&"
import style0 from "./EditTranscriptPrompt.vue?vue&type=style&index=0&id=d62d66fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62d66fe",
  null
  
)

export default component.exports